import { Action } from '@ngrx/store';

export const SET_CURRENT_USER_ACTION = 'SET_CURRENT_USER_ACTION';

export class SetCurrentUserAction implements Action {

    readonly type: string = SET_CURRENT_USER_ACTION;

    constructor(public payload?: string) {

    }

}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/actions/SetCurrentUserAction.ts